import Cookies from 'universal-cookie'

export const setCookie = (cookieName: string, value: string) => {
  const endOfDay = new Date()
  endOfDay.setHours(23, 59, 59, 999)

  const cookies = new Cookies(null, {path: '/'})
  cookies.set(cookieName, value, {
    path: '/',
    expires: endOfDay,
  })
  return {credentialsFromCookie: value}
}
export const getCookie = (cookieName: string) => {
  const cookies = new Cookies(null, {path: '/'})
  return cookies.get(cookieName)
}
export const removeCookie = (cookieName: string) => {
  const cookies = new Cookies(null, {path: '/'})
  cookies.remove(cookieName, {path: '/'})
}
